import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../resources/Example_Job.jpg';

const Hero = () => {
    return (
        <section className="hero hero--animated" id="top">
            <div className="container hero__inner">
                <div className="hero__text">
                    <div className="hero__eyebrow">Local home &amp; office cleaning</div>

                    <h1 className="hero__title">
                        Thoughtful residential &amp; commercial cleaning
                    </h1>

                    {/* NEW: location banners directly under the title */}
                    <div className="hero__locations-row">
                        <div className="hero__locations-label">Serving</div>
                        <div className="hero__locations-badges">
                            <a href="#areas" className="hero__location-banner">
                                <span className="hero__location-pill-dot" />
                                Guelph
                            </a>
                            <a href="#areas" className="hero__location-banner">
                                <span className="hero__location-pill-dot" />
                                Kitchener
                            </a>
                            <a href="#areas" className="hero__location-banner">
                                <span className="hero__location-pill-dot" />
                                Waterloo
                            </a>
                            <a href="#areas" className="hero__location-banner">
                                <span className="hero__location-pill-dot" />
                                Cambridge
                            </a>
                        </div>
                    </div>

                    <p className="hero__subtitle">
                        Trusted by local homeowners &amp; businesses. Eco-friendly products, flexible
                        scheduling, and detail-oriented cleaning.
                    </p>
                    <div className="hero__actions">
                        <Link to="/quote" className="btn btn-primary">
                            Get a Free Quote
                        </Link>
                        <a href="tel:+15197318214" className="btn btn-ghost">
                            Call +1 519-731-8214
                        </a>
                    </div>
                    <div className="hero__note">
                        Residential homes • Commercial buildings •  &amp; even rental properties
                    </div>
                </div>

                <div className="hero__image-wrapper">
                    <img
                        src={heroImage}
                        alt="Clean, fresh spaces for your home and office"
                        className="hero__image"
                    />
                    <span className="hero__image-text">
                        Clean, fresh spaces for your home &amp; office
                    </span>
                </div>
            </div>
        </section>
    );
};

export default Hero;
